export const FuelIcon = () => {
    return (
        <svg width="100%" height="100%" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M7.5 55H37.5M10 22.5H35M35 55V10C35 8.67392 34.4732 7.40215 33.5355 6.46447C32.5979 5.52678 31.3261 5 30 5H15C13.6739 5 12.4021 5.52678 11.4645 6.46447C10.5268 7.40215 10 8.67392 10 10V55M35 32.5H40C41.3261 32.5 42.5979 33.0268 43.5355 33.9645C44.4732 34.9021 45 36.1739 45 37.5V42.5C45 43.8261 45.5268 45.0979 46.4645 46.0355C47.4021 46.9732 48.6739 47.5 50 47.5C51.3261 47.5 52.5979 46.9732 53.5355 46.0355C54.4732 45.0979 55 43.8261 55 42.5V24.575C55.0005 23.9152 54.8705 23.2619 54.6173 22.6526C54.3642 22.0433 53.9929 21.4901 53.525 21.025L45 12.5"
                stroke="url(#paint0_linear_326_3214)" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round"/>
            <defs>
                <linearGradient id="paint0_linear_326_3214" x1="34.5259" y1="-22.9412" x2="104.475" y2="80.8187"
                                gradientUnits="userSpaceOnUse">
                    <stop stopColor="#F83700"/>
                    <stop offset="1" stopColor="#F7CB2A"/>
                </linearGradient>
            </defs>
        </svg>
    );
};